import { SHOW_GLOBAL_LOADER, HIDE_GLOBAL_LOADER } from '../types';

const initialState = {
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
      return {
        show: true,
      };
    case HIDE_GLOBAL_LOADER:
      return {
        show: false,
      };

    default:
      return state;
  }
};
